// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1Wu45","signatureButtonsRight":"ModalSign_signatureButtonsRight__115th"};